import { createGenericReducer } from "common/genericReducer";
import { AUTH_RECEIVED, AUTH_REQUESTED, AUTH_REQUEST_FAILED, AUTH_SIGN_OUT } from "./authActions";

export const auth = createGenericReducer(AUTH_REQUESTED, AUTH_RECEIVED, AUTH_REQUEST_FAILED, AUTH_SIGN_OUT);
